import React from 'react';

import {SubTitleLarge} from '@spaced-out/ui-design-system/lib/components/Text';
import {SemanticIcon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {
  Card,
  CardContent,
} from '@spaced-out/ui-design-system/lib/components/Card';
import type {AlertSemanticType} from '@spaced-out/ui-design-system/lib/types/common';

import css from './small-card.css';


interface SmallCardProps {
  title: string;
  icon: string;
  children: React.ReactNode;
  iconSemantic?: AlertSemanticType;
}

export const SmallCard = ({
  children,
  icon,
  title,
  iconSemantic = 'information',
}: SmallCardProps) => {
  return (
    <Card classNames={{wrapper: css.cardWrapper}}>
      <CardContent className={css.cardContent}>
        <div className={css.cardHeader}>
          <SemanticIcon
            semantic={iconSemantic}
            size="large"
            name={icon}
            type="solid"
          />
          {/* Translated at the caller */}
          {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
          <SubTitleLarge>{title}</SubTitleLarge>
        </div>
        {/* Children are react components */}
        {/* eslint-disable-next-line @spaced-out/i18n/no-dynamic-labels */}
        {children}
      </CardContent>
    </Card>
  );
};
